import { css } from "@emotion/react";
import { media } from "styles/breakpoints";

export const NodataStyle = {
  wrapper: css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    ${media.md} {
      justify-content: center;
    }
    gap: 3.75px;

    padding: 16px 0;

    background-color: #fcf8e3;
    border: 1px solid #faebcc;
    span {
      color: #8a6d3b;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      margin-left: 10px;
      ${media.md} {
        margin-left: unset;
      }
    }
    svg {
      display: none;
      ${media.md} {
        display: block;
      }
      fill: #8a6d3b;
    }
  `,
};
